// extracted by mini-css-extract-plugin
export default {"noAssigneeContainer":"assignees-module__noAssigneeContainer--xwRz4","assigneeIconLink":"assignees-module__assigneeIconLink--qvyme"};